import {updateEmail, User as FirebaseUser} from "@firebase/auth";
import {auth} from "../../firebase/firebase-config";
import {toAccountsError} from "../../firebase/errors";
import {useState} from "react";
import {waitAtLeast} from "../../test/test-util";
import {reauthenticateWithEmail} from "./reauthenticate";
import {translateKey} from "../language/translate";

export type ChangeEmailFn = (email: string, password: string) => Promise<void>

export type UseChangeEmailResult = {
  changeEmail?: ChangeEmailFn
  isSubmitting: boolean
  isSuccess: boolean
  clearSuccess: () => void
}

export const useChangeEmail = (minLoadingTime = 500): UseChangeEmailResult => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  let changeEmail = undefined;
  if (auth.currentUser) {
    changeEmail = async (newEmail: string, password: string) => {
      if (!auth.currentUser) {
        throw new Error(translateKey("account:validation.userNotSignedIn"));
      }
      setIsSubmitting(true);
      await waitAtLeast(doChangeEmail(auth.currentUser, newEmail, password), minLoadingTime).
        finally(() => setIsSubmitting(false));
      setIsSuccess(true);
    };
  }
  return {changeEmail, isSubmitting, isSuccess, clearSuccess: () => setIsSuccess(false)};
};

const doChangeEmail = async (user: FirebaseUser, newEmail: string, password: string) => {
  const oldEmail = user.email;
  if (!oldEmail) {
    throw new Error("old email is missing");
  }
  await reauthenticateWithEmail(user, oldEmail, password).
    then(() => updateEmail(user, newEmail)).
    then(() => reauthenticateWithEmail(user, newEmail, password)).
    catch(err => Promise.reject(toAccountsError(err, "invalidUsernameOrPassword")));
};
